window.addEventListener("load", () => {
  const slider = document.querySelector(".gr-greeting-card-gallery__thumbs .gr-thumbnail-list");
  const prevItem = document.querySelector(".gr-greeting-card-gallery__nav-item--prev");
  const nextItem = document.querySelector(".gr-greeting-card-gallery__nav-item--next");

  if (slider && nextItem && prevItem) {
    const updateGreetingCardShadows = () => {
      slider.classList.remove("show-left-shadow", "show-right-shadow");

      if (slider.scrollLeft > 0) {
        slider.classList.add("show-left-shadow");
      }

      if (slider.scrollLeft + slider.clientWidth < slider.scrollWidth) {
        slider.classList.add("show-right-shadow");
      }
    };

    const observerNext = new MutationObserver(updateGreetingCardShadows);
    const observerPrev = new MutationObserver(updateGreetingCardShadows);

    observerNext.observe(nextItem, { attributes: true, attributeFilter: ["disabled"] });
    observerPrev.observe(prevItem, { attributes: true, attributeFilter: ["disabled"] });

    slider.addEventListener("scroll", updateGreetingCardShadows);
    slider.addEventListener("touchmove", updateGreetingCardShadows);

    updateGreetingCardShadows();
  }
});